export default function parseFloat3(number) {
  return parseFloat(number).toFixed(3);
}
